export const timeInStageBorders = {
  warningDays: 2,
  errorDays: 5,
};

export const applicationFilters = [
  { id: 'pool', label: 'Recruiting Pool' },
  { id: 'specialization', label: 'Specialization' },
  { id: 'technology', label: 'Technology' },
  { id: 'level', label: 'Level' },
  { id: 'status', label: 'Status' },
  { id: 'stage', label: 'State' },
] as const;
